import pythonApiClient from "./pythonBaseApi";

const bancosApi = {
  /**
   * Obtener todos los bancos
   * @param {boolean} activo - Filtrar solo bancos activos
   * @returns {Promise} Lista de bancos
   */
  getBancos: (activo = true) => {
    return pythonApiClient.get("/corporativo/bancos", {
      params: { activo },
    });
  },

  /**
   * Obtener banco por ID
   * @param {number} bancoId - ID del banco
   * @returns {Promise} Datos del banco
   */
  getBancoById: (bancoId) => {
    return pythonApiClient.get(`/corporativo/bancos/${bancoId}`);
  },

  /**
   * Crear nuevo banco
   * @param {Object} bancoData - Datos del banco
   * @returns {Promise} Banco creado
   */
  createBanco: (bancoData) => {
    return pythonApiClient.post("/corporativo/bancos", bancoData);
  },

  /**
   * Actualizar banco
   * @param {number} bancoId - ID del banco
   * @param {Object} bancoData - Datos a actualizar
   * @returns {Promise} Banco actualizado
   */
  updateBanco: (bancoId, bancoData) => {
    return pythonApiClient.put(`/corporativo/bancos/${bancoId}`, bancoData);
  },

  /**
   * Eliminar banco
   * @param {number} bancoId - ID del banco
   * @returns {Promise} Resultado de la eliminación
   */
  deleteBanco: (bancoId) => {
    return pythonApiClient.delete(`/corporativo/bancos/${bancoId}`);
  },
};

export default bancosApi;
